import ScalarCopyBackdrop_default from "../ScalarCopy/ScalarCopyBackdrop.vue.js";
import ScalarCodeBlockCopy_default from "./ScalarCodeBlockCopy.vue.js";
import { useBindCx } from "@scalar/use-hooks/useBindCx";
import { computed, createBlock, createCommentVNode, createElementBlock, createElementVNode, createVNode, defineComponent, guardReactiveProps, normalizeClass, normalizeProps, openBlock, unref, useId, withCtx } from "vue";
import { standardLanguages, syntaxHighlight } from "@scalar/code-highlight";
import { prettyPrintJson } from "@scalar/helpers/json/pretty-print-json";
//#region src/components/ScalarCodeBlock/ScalarCodeBlock.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = ["aria-label"];
var _hoisted_2 = ["id", "innerHTML"];
var ScalarCodeBlock_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	inheritAttrs: false,
	__name: "ScalarCodeBlock",
	props: {
		label: { default: "Code sample" },
		content: {},
		prettyPrintedContent: {},
		lang: { default: "plaintext" },
		lineNumbers: {
			type: Boolean,
			default: false
		},
		hideCredentials: {},
		copy: {
			type: [String, Boolean],
			default: "hover"
		}
	},
	setup(__props) {
		/** Base id for the code block */
		const id = useId();
		/** Formatted the content into an indented json string */
		const prettyContent = computed(() => __props.prettyPrintedContent || prettyPrintJson(__props.content ?? ""));
		const highlightedCode = computed(() => {
			return syntaxHighlight(prettyContent.value, {
				lang: __props.lang.trim(),
				languages: standardLanguages,
				lineNumbers: __props.lineNumbers,
				maskCredentials: __props.hideCredentials
			}).slice(5, -6);
		});
		/** Determine if the content is a single line */
		const isOneLine = computed(() => !prettyContent.value.includes("\n"));
		const isContentValid = computed(() => {
			return prettyContent.value !== null && prettyContent.value !== "null" && prettyContent.value !== "404 Not Found";
		});
		/** Whether the copy button is rendered on top of the code */
		const showCopy = computed(() => __props.copy && isContentValid.value);
		/**
		* A one-liner has the copy button floating over the end of the line, so the line needs room to
		* scroll clear of the button. The padding goes on the `w-fit` <pre> because browsers disagree about
		* whether trailing padding on an `overflow-x` container is scrollable.
		*/
		const reserveCopySpace = computed(() => isOneLine.value && showCopy.value);
		const { cx } = useBindCx();
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", normalizeProps(guardReactiveProps(unref(cx)("scalar-code-block group/code-block flex flex-col", "relative bg-b-1 min-h-0 min-w-0 focus-visible:outline"))), [createElementVNode("div", {
				"aria-label": __props.label,
				class: "custom-scroll overflow-x-auto p-2 -outline-offset-2 rounded-[inherit] min-h-0 min-w-0 flex-1",
				role: "region",
				tabindex: "0"
			}, [createElementVNode("pre", {
				id: unref(id),
				class: normalizeClass(["m-0 bg-transparent text-nowrap whitespace-pre w-fit", { "pr-6": reserveCopySpace.value }]),
				innerHTML: highlightedCode.value
			}, null, 10, _hoisted_2)], 8, _hoisted_1), showCopy.value ? (openBlock(), createBlock(unref(ScalarCodeBlockCopy_default), {
				key: 0,
				"aria-controls": unref(id),
				class: normalizeClass(["scalar-code-copy absolute", [isOneLine.value ? "top-1/2 -translate-y-1/2 m-0 right-1" : "top-2.5 right-2.5", { "opacity-100": __props.copy === "always" }]]),
				content: prettyContent.value,
				lang: __props.lang,
				showLang: !isOneLine.value
			}, {
				backdrop: withCtx(() => [createVNode(ScalarCopyBackdrop_default, { class: normalizeClass(["scalar-code-copy-backdrop", [isOneLine.value ? "-inset-y-0.75 -right-1 group-hocus-within/code-block:-left-0.5 left-3" : "-right-1.5 -top-1"]]) }, null, 8, ["class"])]),
				_: 1
			}, 8, [
				"aria-controls",
				"class",
				"content",
				"lang",
				"showLang"
			])) : createCommentVNode("", true)], 16);
		};
	}
});
//#endregion
export { ScalarCodeBlock_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ScalarCodeBlock.vue.script.js.map